import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function AutoLogin() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const token = params.get('token')
    if (!token) {
      console.error('[Sandbox] auto-login: no token in URL')
      navigate('/login', { replace: true })
      return
    }

    localStorage.setItem('smm_token', token)
    window.dispatchEvent(new Event('storage'))
    navigate('/connections', { replace: true })
  }, [params, navigate])

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      <p>Signing in...</p>
    </div>
  )
}
